// extracted by mini-css-extract-plugin
export var printerCard = "_i9-1";
export var printerCardConfigured = "_i9-2";
export var printerCardError = "_i9-3";
export var printerCardsContainer = "_i9-0";
export var printerIcon = "_i9-8";
export var printerIconConfigured = "_i9-5";
export var printerIconContainer = "_i9-4";
export var printerIconError = "_i9-6";
export var printerIconUnconfigured = "_i9-7";
export var workstationsTableCard = "_i9-9";